import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import FilterButtons from '../components/FilterButtons.react.js';
import FormFilterProgramatica from '../programatica/FormFilterProgramatica.react';

const FormFilter = ({
  filtros,
  onConsulta,
  onReset,
  onChange,
  tiposTransferencias
}) => {
  const f = filtros || Map({});
  const tipos = tiposTransferencias || List();

  return (
    <form onSubmit={onConsulta}>
      <Row>
        <Col xs={6} sm={4} md={2}>
          <Input
            id="numeroEmenda"
            name="numeroEmenda"
            placeholder="Informe o Número da Emenda"
            label="Número Emenda"
            type="number"
            min={0}
            onChange={onChange}
            value={f.get('numeroEmenda', '')}
          />
        </Col>
        <Col xs={6} sm={4} md={4}>
          <Input
            id="nomeAutor"
            name="nomeAutor"
            placeholder="Informe o Autor da Emenda"
            label="Autor da Emenda"
            type="text"
            onChange={onChange}
            value={f.get('nomeAutor', '')}
          />
        </Col>
        <Col xs={12} sm={4} md={2}>
          <Input
            id="tipoTransferencia"
            name="tipoTransferencia"
            label="Tipo de Transferência"
            type="select"
            onChange={onChange}
            value={f.get('tipoTransferencia', '')}
          >
            <option value="">Todos</option>

            {tipos.map(item => (
              <option key={item.get('codigo')} value={item.get('codigo')}>
                {item.get('descricao')}
              </option>
            ))}
          </Input>
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Input
            id="planoAcao"
            name="planoAcao"
            placeholder="Informe o Plano de Ação"
            label="Plano de Ação"
            type="text"
            onChange={onChange}
            value={f.get('planoAcao', '')}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={6} sm={3} md={2}>
          <Input
            id="cnpjCpf"
            name="cnpjCpf"
            placeholder="Informe o CNPJ/CPF"
            label="CNPJ/CPF"
            type="text"
            onChange={onChange}
            value={f.get('cnpjCpf', '')}
          />
        </Col>
        <Col xs={6} sm={3} md={4}>
          <Input
            id="nomeFornecedor"
            name="nomeFornecedor"
            placeholder="Informe o Nome do Fornecedor"
            label="Nome do Fornecedor"
            type="text"
            onChange={onChange}
            value={f.get('nomeFornecedor', '')}
          />
        </Col>
        <Col xs={6} sm={3} md={3}>
          <Input
            id="empenhoInicial"
            name="empenhoInicial"
            placeholder="Empenho Inicial"
            label="Empenho Inicial"
            type="number"
            min={0}
            onChange={onChange}
            value={f.get('empenhoInicial', '')}
          />
        </Col>
        <Col xs={6} sm={3} md={3}>
          <Input
            id="empenhoFinal"
            name="empenhoFinal"
            placeholder="Empenho Final"
            label="Empenho Final"
            type="number"
            min={0}
            onChange={onChange}
            value={f.get('empenhoFinal', '')}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={6} sm={3} md={3}>
          <DatePicker
            id="dataInicial"
            name="dataInicial"
            label="Data Inicial Emissão"
            onChange={onChange}
            value={f.get('dataInicial', '')}
          />
        </Col>
        <Col xs={6} sm={3} md={3}>
          <DatePicker
            id="dataFinal"
            name="dataFinal"
            label="Data Final Emissão"
            onChange={onChange}
            value={f.get('dataFinal', '')}
          />
        </Col>
        <Col xs={6} sm={3} md={3}>
          <DatePicker
            id="dataInicioMovimentacao"
            name="dataInicioMovimentacao"
            label="Data Inicial Movimentação"
            onChange={onChange}
            value={f.get('dataInicioMovimentacao', '')}
          />
        </Col>
        <Col xs={6} sm={3} md={3}>
          <DatePicker
            id="dataFimMovimentacao"
            name="dataFimMovimentacao"
            label="Data Final Movimentação"
            onChange={onChange}
            value={f.get('dataFimMovimentacao', '')}
          />
        </Col>
      </Row>

      <FormFilterProgramatica filtros={filtros} onChange={onChange} />

      <FilterButtons
        idBtnReset="btnResetFilter"
        onConsulta={onConsulta}
        onReset={onReset}
      />
    </form>
  );
};

FormFilter.propTypes = {
  filtros: PropTypes.instanceOf(Map),
  onConsulta: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  tiposTransferencias: PropTypes.instanceOf(List)
};

export default FormFilter;
